import React, { HTMLProps } from 'react';
import { useState } from 'react';

export default function ExpiryDateInput(props: HTMLProps<HTMLInputElement>) {
  const [date, setDate] = useState('');
  return (
    <input
      {...props}
      placeholder="MM / YY"
      autoComplete="cc-exp"
      maxLength={7}
      value={date}
      onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
        setDate(formatDate(e.target.value))
      }
    />
  );
}

function formatDate(date: string) {
  const parts = date.match(/\d{1,2}/g);
  if (!parts) return '';
  return parts.join(' / ');
}
